
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protection/uci",
      function () {
        return require("private-next-pages/protection/uci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protection/uci"])
      });
    }
  